/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import LogoBranca from "../../assets/images/adaptive-icon.png";
import AdComponent from "../AdComponent";

import {
  StyledFooter,
  StyledFooterInner,
  StyledFooterTopRow,
  StyledBrandCol,
  StyledInfoCol,
  StyledBrand,
  StyledLogo,
  StyledBrandText,
  StyledInfo,
  StyledFooterBottomRow,
  StyledCopyright,
  StyledAdSlot,
} from "./styles";

const Footer: React.FC = () => {
  return (
    <StyledFooter>
      <StyledFooterInner>
        <StyledFooterTopRow
          justify="space-between"
          align="middle"
          gutter={[16, 20]}
        >
          <StyledBrandCol xs={24} md={14} lg={15}>
            <StyledBrand>
              <StyledLogo src={LogoBranca} alt="Bilíngua Consultoria" />
              <StyledBrandText>
                <span>Bilíngua Consultoria</span>
                <small>CNPJ: 40.146.101/0001-90</small>
              </StyledBrandText>
            </StyledBrand>
          </StyledBrandCol>

          <StyledInfoCol xs={24} md={10} lg={9}>
            <StyledInfo>
              Soluções em acessibilidade e educação bilíngue.
            </StyledInfo>
          </StyledInfoCol>
        </StyledFooterTopRow>

        <StyledFooterBottomRow justify="center">
          <StyledAdSlot>
            <AdComponent />
          </StyledAdSlot>
          <StyledCopyright>
            &copy; {new Date().getFullYear()} Bilíngua Consultoria — Todos os
            direitos reservados.
          </StyledCopyright>
        </StyledFooterBottomRow>
      </StyledFooterInner>
    </StyledFooter>
  );
};

export default Footer;
